export default [
  {
    field: 'workPhone',
    method: 'isMobilePhone',
    options: ['en-US'],
    validWhen: true,
    message: 'Phone number must be in format ###-###-####',
  },
  {
    field: 'industryCode',
    method: 'isEmpty',
    validWhen: false,
    message: 'A selection is required',
  },
  {
    field: 'industryCode',
    method: 'isLength',
    validWhen: true,
    message: 'A selection is required',
    options: [{ min: 1 }],
  },
  {
    field: 'jobCode',
    method: 'isEmpty',
    validWhen: false,
    message: 'A selection is required',
  },
  {
    field: 'jobCode',
    method: 'isLength',
    validWhen: true,
    message: 'A selection is required',
    options: [{ min: 1 }],
  },
];
